export default __webpack_public_path__ + "static/cleaning_tools-8503ab3c7cb2c2354797a2cddd1f7218.jpg";